import React from 'react';
import { useTranslation } from 'react-i18next';

function Cases() {
  const { t } = useTranslation();
  
  const images = [
    '/home1/assets/img/slider/head_slide1.jpg',
    '/home1/assets/img/slider/2.jpg',
    '/home1/assets/img/slider/3.jpg',
    '/home1/assets/img/slider/4.jpg',
    '/home1/assets/img/slider/5.jpg',
    '/home1/assets/img/slider/6.jpg',
    '/home1/assets/img/slider/head_slide5.jpg',
    '/home1/assets/img/slider/head_slide6.jpg',
    '/home1/assets/img/slider/head_slide7.jpg',
    '/home1/assets/img/slider/head_slide8.jpg',
    '/home1/assets/img/slider/head_slide10.jpg',
    '/home1/assets/img/slider/IMG_0062.jpeg',
    '/home1/assets/img/slider/IMG_0578.jpeg',
    '/home1/assets/img/slider/IMG_7468.jpg',
    '/home1/assets/img/slider/IMG_9581.jpeg',
    '/home1/assets/img/slider/Botanicheska.jpeg',
    '/home1/assets/img/slider/PrestigePark1.jpeg',
    '/home1/assets/img/slider/Garden.jpeg',
    '/home1/assets/img/slider/Garden1.jpeg',
    '/home1/assets/img/slider/PrestigePark.jpeg',
    '/home1/assets/img/projects/proj1.jpg',
    '/home1/assets/img/projects/proj2.jpg',
    '/home1/assets/img/projects/proj3.jpg',
    '/home1/assets/img/projects/proj4.jpg',
    '/home1/assets/img/projects/proj5.jpg',
    '/home1/assets/img/projects/proj6.jpg',
    '/home1/assets/img/projects/proj7.jpg'
  ];
  return (
    <section className="tc-cases-style10 section-padding-x" style={{ 
      paddingTop: '60px', 
      paddingBottom: '100px',
      backgroundColor: '#ffffff'
    }}>
      <div className="container-fluid">
        <div className="cases-content">
          <style>{`
            .tc-cases-style10 .case-item {
              opacity: 1 !important;
              visibility: visible !important;
              animation: none !important;
              transform: none !important;
            }
            .tc-cases-style10 .case-item img {
              opacity: 1 !important;
              animation: none !important;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .tc-cases-style10 .wow {
              visibility: visible !important;
              animation: none !important;
            }
            .tc-cases-style10 .img {
              min-height: 300px;
              height: 100%;
            }
            @media (max-width: 991px) {
              .tc-cases-style10 .img {
                min-height: 250px;
              }
            }
            @media (max-width: 767px) {
              .tc-cases-style10 .img {
                min-height: 200px;
              }
            }
          `}</style>
          <div className="row g-4">
            {images.map((src, i) => {
              // Pattern: 3 items per row (col-lg-4), then 2 items per row (col-lg-6)
              const isThreeColumn = i % 5 < 3; // First 3 items (0,1,2) in each group of 5
              const colClass = isThreeColumn ? '4' : '6';
              return (
              <div key={i} className={`col-12 col-md-6 col-lg-${colClass}`}>
                <div className={`case-item d-none d-lg-block`} style={{ opacity: 1, visibility: 'visible' }}>
                  <div className="img position-relative overflow-hidden" style={{
                    borderRadius: '16px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    opacity: 1,
                    transform: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                  }}>
                    <img 
                      src={src} 
                      alt={`gallery-${i}`} 
                      className="img-cover" 
                      loading="eager"
                      style={{
                        borderRadius: '16px',
                        transition: 'transform 0.3s ease',
                        opacity: 1,
                        display: 'block'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                      }}
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
                         style={{
                           background: 'rgba(0,0,0,0.3)',
                           opacity: 0,
                           transition: 'opacity 0.3s ease',
                           borderRadius: '16px',
                           pointerEvents: 'none'
                         }}
                         onMouseEnter={(e) => {
                           e.currentTarget.style.opacity = '1';
                         }}
                         onMouseLeave={(e) => {
                           e.currentTarget.style.opacity = '0';
                         }}>
                      <i className="fa fa-search-plus text-white" style={{ fontSize: '2rem' }}></i>
                    </div>
                  </div>
                </div>
                <div className={`case-item d-block d-lg-none`} style={{ opacity: 1, visibility: 'visible' }}>
                  <div className="img position-relative overflow-hidden" style={{
                    borderRadius: '16px',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    opacity: 1,
                    transform: 'none'
                  }}>
                    <img 
                      src={src} 
                      alt={`gallery-${i}`} 
                      className="img-cover" 
                      loading="eager"
                      style={{
                        borderRadius: '16px',
                        transition: 'transform 0.3s ease',
                        opacity: 1,
                        display: 'block'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
                         style={{
                           background: 'rgba(0,0,0,0.3)',
                           opacity: 0,
                           transition: 'opacity 0.3s ease',
                           borderRadius: '16px',
                           pointerEvents: 'none'
                         }}>
                      <i className="fa fa-search-plus text-white" style={{ fontSize: '1.5rem' }}></i>
                    </div>
                  </div>
                </div>
              </div>
            );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cases;
